<template>
  <div class="app-layout" :class="[ boxed ? 'app-layout--boxed' : '']">
    <menu-wrapper
            v-if="isVerticalMenuActive" :is-vertical-menu-active="isVerticalMenuActive"
            :is-vertical-menu-collapsed="isVerticalMenuCollapsed"
            :toggle-vertical-menu="toggleVerticalMenu"
            :style="[{'width': isVerticalMenuActive ? !isVerticalMenuCollapsed ? isVerticalMenuCollapsedConfig.true : isVerticalMenuCollapsedConfig.false : '0px' }]"
    >
      <template #content>
        <slot name="verticalMenu"></slot>
      </template>
    </menu-wrapper>
    <content-wrapper>
      <template #content>
        <slot name="content"></slot>
      </template>
    </content-wrapper>
<!--                :style="[{'margin-left': isVerticalMenuActive ? !isVerticalMenuCollapsed ? isVerticalMenuCollapsedConfig.true : isVerticalMenuCollapsedConfig.false : '0px' }]"-->
  </div>
</template>

<script>
import MenuWrapper from "./appLayoutElements/menu-wrappper/MenuWrapper";
import ContentWrapper from "./appLayoutElements/content-wrapper/ContentWrapper";
import useAppLayout from './useAppLayout'

import { watch } from '@vue/composition-api'



export default {
  components: {
    MenuWrapper,
    ContentWrapper,
  },

  props: {
    isVerticalMenuActive: {
      type: Boolean,
      default: false,
      required: true
    },
    isVerticalMenuCollapsed: {
      type: Boolean,
      default: true,
      required: true
    },
    isVerticalMenuCollapsedConfig: {
      type: Object,
      default: ()=>{
        return {
          true: '320px',
          false: '80px'
        }
      },
      required: false
    },
    boxed: {
      type: Boolean,
      default: true,
      required: false
    },

  },


  setup(props, {emit}) {

    const {
      isVerticalMenuActive,
      isVerticalMenuCollapsed,
      toggleVerticalMenu
    } = useAppLayout({
      isVerticalMenuActive: props.isVerticalMenuActive,
      isVerticalMenuCollapsed: props.isVerticalMenuCollapsed
    })

    watch([isVerticalMenuCollapsed], () => {
      emit('is-vertical-menu-collapsed', isVerticalMenuCollapsed.value)
    })

    return {
      toggleVerticalMenu
    }
  },
}
</script>

<style lang="scss">
  .app-layout {
    position: relative;
    height: 100%;
    display: flex;
  }

</style>


